import FinalCta from '@/components/sections/services/final-cta';
import Grid from '@/components/sections/services/grid';
import Hero from '@/components/sections/services/hero';

import { Page } from '@/components/layout/page';

export default function HomePage() {
    return (
        <Page title="Les informations officielles des entreprises">
            <Hero />
            <Grid />
            <FinalCta />
        </Page>
    );
}